import { nanoid } from 'nanoid';
import type { ToastProps } from '../../components/common/Toast/Toast';
import type { ThunkResult } from '../types';
import logger from '../../modules/logging/logger';

export type ToastsActions =
    | {
          type: 'ADD_TOAST';
          data: ToastProps;
      }
    | {
          type: 'EDIT_TOAST';
          data: ToastProps;
      }
    | {
          type: 'REMOVE_TOAST';
          data: ToastProps;
      }
    | {
          type: 'REMOVE_TOAST_BY_ID';
          data: { id: string };
      }
    | {
          type: 'REMOVE_ALL_TOASTS';
      };

export const addToast =
    (toast: ToastProps): ThunkResult<void> =>
    (dispatch, getState) => {
        if (toast.id) {
            const toasts = getState().global.toasts;
            const existingToast = toasts.find((t) => t.id === toast.id);
            if (existingToast) {
                // don't show duplicate toasts
                logger.log('Prevented showing duplicate toast', { toast });
                return;
            }
        }

        dispatch({
            type: 'ADD_TOAST',
            data: {
                ...toast,
                id: toast.id ?? nanoid()
            }
        });
    };

export const editToast =
    (toast: ToastProps): ThunkResult<void> =>
    (dispatch, getState) => {
        if (!toast.id) {
            return;
        }

        const toasts = getState().global.toasts;
        const existingToast = toasts.find((t) => t.id === toast.id);

        if (!existingToast) {
            return;
        }

        dispatch({
            type: 'EDIT_TOAST',
            data: toast
        });
    };

export const removeToast = (toast: ToastProps): ToastsActions => ({
    type: 'REMOVE_TOAST',
    data: toast
});

export const removeToastById = (id: string): ToastsActions => ({
    type: 'REMOVE_TOAST_BY_ID',
    data: { id }
});

export const removeAllToasts = (): ToastsActions => ({
    type: 'REMOVE_ALL_TOASTS'
});
